declare namespace $ {

	type $mol_view__sub_shm_dashboard_app_dashboard_list_head_1 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_dashboard_list_head['controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_dashboard_app_dashboard_list_head extends $shm_list_head {
		controls( ): readonly(any)[]
		search_showed( ): boolean
		add_content( ): readonly(any)[]
		close_content( ): readonly(any)[]
		settings_content( ): readonly(any)[]
		Controls( ): $mol_view
	}
	
}

//# sourceMappingURL=head.view.tree.d.ts.map